import React from "react";

/** Lightweight numbered paginator matching the screenshots ( < 1 2 3 > ). */
const SimplePaginator = ({ page, pageCount, onChange }) => {
  if (pageCount <= 1) return null;
  const pages = Array.from({ length: pageCount }, (_, i) => i + 1);
  return (
    <div className="cuc-paginator">
      <button
        className="cuc-page-btn"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        aria-label="previous"
      >
        {"<"}
      </button>
      {pages.map((p) => (
        <button
          key={p}
          className={`cuc-page-btn ${p === page ? "is-active" : ""}`}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}
      <button
        className="cuc-page-btn"
        disabled={page >= pageCount}
        onClick={() => onChange(page + 1)}
        aria-label="next"
      >
        {">"}
      </button>
    </div>
  );
};

export default SimplePaginator;
